module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("k92s2"))).then(() => module.bundle.root('jnagv'));